import { AccountTypeInterface } from "../model/BookingModel";
import { ACCOUNT, CASH, FREE_OF_COST_TEXT, FOD, FOD_ID } from "../utils/app-common";

export const getUniqueId = () => Math.random().toString(36).substring(2);
export type IStringNUmberUndefinedType = string | number | undefined;
export const initialDropDown = { id: 0, value: '' };

export const cancelLabel = (text: string) => `Are you sure, you want to cancel ${text} ?`
export const rtoLabel = (text: string) => `Are you sure, you want to RTO ${text} ?`
export const rtoCancelLabel = (text: string) => `Are you sure, you want to cancel RTO waybill ${text} ? This action cannot be undone.`
export const deleteLabel = (text: IStringNUmberUndefinedType) => `Are you sure, you want to delete ${text} ?`
export const activateLabel = (text: IStringNUmberUndefinedType) => `Are you sure, you want to activate ${text} ?`
export const deactivateLabel = (text: IStringNUmberUndefinedType) => `Are you sure, you want to deactivate ${text} ?`


const VALIDATION_MESSAGE = {
    EMAIL_ADDRESS: 'You have entered an invalid e-mail address',
}

export const validationMessage = {
    INVALID_EMAIL_ADDRESS: VALIDATION_MESSAGE.EMAIL_ADDRESS,
    INVALID_PHONE_NUMBER: 'You have entered an invalid phone number',
    INVALID_TEXT: 'You have entered an invalid text. Please add number only',
    INVALID_2_DIGIT_DECIMAL_NUMBER: 'You have entered an invalid text. Please enter numbers from 1 and only 2 digits allowed after the decimal point',
    INVALID_TEXT_WITH_SPECIAL_CHARACTER: 'You have entered an invalid text. Please add number from 1 with or without (-)',
    ALPHABETS_TEXT: 'You have entered an invalid text. Please add alphabets only',
    INVALID_SWIFT: 'You have entered invalid SWIFT CODE',
    INVALID_IBAN: 'You have entered invalid IBAN',
    INVALID_BANK_ACCOUNT: 'You have entered invalid Bank Account',
    PHONE_NUMBER_LIMIT: 'Phone number must be 10 digit only',
    IDENTITY_NUMBER_LIMIT: 'Identity number must be 10 digit only And contains only numbers',
    ISSUE_NUMBER_LIMIT: 'Identity number must be 3 digit only',
    REQUIRED: 'This field is required.',
    GREATER_THAN_ZERO: 'Greater than zero is not allowed',
    GREATER_OR_LESS_THAN_TOTAL_PIECES: 'Pieces should not be greater or less than total piece count',
    REFERENCE_NUMBER_LENGTH: 'The reference number must be 70 characters long',
    ARABIC_ALPHABETS_TEXT: 'You have entered an invalid text. Please add arabic alphabets only',
    MAP_NUMBER_LENGTH: 'The reference number must be 150 characters long',
    INVALID_FOUR_DIGITS_NUMBER: 'You have entered an invalid text. Please add number only and not more than 4 digits',
    INVALID_TWO_DIGITS_NUMBER: 'You have entered an invalid text. Please add number only and not more than 2 digits',
    INVALID_THREE_DIGITS_NUMBER: 'You have entered an invalid text. Please add number only and not more than 3 digits',
    INVALID_ONE_ALPHA_CODE: 'invalid, one character code is required.',
    INVALID_TWO_ALPHA_CODE: 'invalid, two character code is required.',
    INVALID_TWO_DIGIT_DECIMAL_WITH_ONE_DIGIT_PRECISION: 'Please add number only and not more than 2 digits before decimal and 1 digit after decimal',
    SUBJECT_COMPLAINT_LENGTH: 'The subject must not be more than 45 characters long',
    EXCEPTION_REMARKS_LENGTH: 'The remarks must not be more than 250 characters long',
    INVALID_SAUDI_PLATE_NUMBER: 'Invalid plate number, please make sure you entered the plate number (not starting with 0) and the 3 letters',
    NAME_FIELD: 'Name can only contains english letters',
    ARABIC_NAME_FIELD: 'Arabic name field can only contains arabic letters',
    VEHICLE_TYPE_FIELD: 'Type must be only contains english letters and between 3 to 50 letters long',
    ALL_LETTERS_NAME_FIELD: 'name field can only contains letters',
    IQAMA_NUMBER: 'Please enter a valid Iqama number. It should be exactly 10 digits long.',
    MARKEN_HAWB_LENGTH: 'The HAWB must be between 10 to 14 characters long And Spaces are NOT allowed and must contain numbers & letters (english letters only)',
    INVALID_POSITIVE_NON_ZERO_DECIMAL_NUMBER: 'You have entered an invalid text. Please add positive non-zero number only',
    PASSWORD: 'Password must be at least 6 characters long with no spaces',
    PASSWORD_COMPLEXITY: 'Password must be 8-15 characters long, contain at least one digit,one alphabet , one special character, and no spaces',
    INVALID_SHORT_ADDRESS: 'You have entered an invalid short address',
     INVALID_CONTACT_NAME: 'whitespaces or only numbers is not allowed. Enter valid letters',
}


export const accountTypeList: AccountTypeInterface[] = [{
    id: 1,
    label: ACCOUNT
},
{
    id: 2,
    label: CASH
},
{
    id: 4,
    label: FREE_OF_COST_TEXT
},
{
    id: FOD_ID,
    label: FOD
},
]

export const APPROVED = 1;
export const REJECTED = 2;

export const downloadBase64File = (base64Data: string, fileName: string, mimeType?: string) => {
    if (!base64Data) {
        console.error("No file data provided.");
        return;
    }

    // If mimeType is not given, try to infer from fileName
    if (!mimeType) {
        const extension = fileName.split(".").pop()?.toLowerCase();

        const mimeMap: Record<string, string> = {
            pdf: "application/pdf",
            png: "image/png",
            jpg: "image/jpeg",
            jpeg: "image/jpeg",
            gif: "image/gif",
            txt: "text/plain",
            csv: "text/csv",
            xls: "application/vnd.ms-excel",
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            doc: "application/msword",
            docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            json: "application/json",
        };

        mimeType = mimeMap[extension || ""] || "application/octet-stream";
    }

    const link = document.createElement("a");
    link.href = `data:${mimeType};base64,${base64Data}`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
